<template>
  <div v-rect-loading="loading" class="agency-management">
    <TableList
      class="agency-list"
      noPagination
      :title="$t('admin.company.agency.title')"
      :listData="listData"
      :tableColumns="tableColumns"
      :actionBtn="actionBtn"
      :showCreateBtn="false"
    >
      <template #btn>
        <el-button class="blue-btn" @click="handelAddAgency">{{ $t(`${i18nPrefix}.btn.addAgency`) }}</el-button>
      </template>
      <template #switchButton="{ row }">
        <div class="switch-container">
          <el-switch
            v-model="row.is_enabled"
            @change="changeStatus($event, row)"
          >
          </el-switch>
        </div>
      </template>
    </TableList>
  </div>
  </template>

<script>
import { mapActions } from 'vuex'
import TableList from '@/components/tableList/allowDragSortTable.vue'
import { isEn } from '@/i18n'

export default {
  components: {
    TableList
  },
  data () {
    return {
      i18nPrefix: 'admin.company.agency',
      isEn,
      loading: false,
      listData: [],
      companyList: [],
      selectCompany: null,
      actionBtn: {
        edit: {
          show: true,
          onclick: this.handleEdit
        }
      }
    }
  },
  created () {
    this.loadAgencyList()
  },
  computed: {
    tableColumns () {
      return [
        {
          label: this.$t(`${this.i18nPrefix}.label.notes`),
          dataKey: 'notes'
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.name`),
          dataKey: 'name'
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.email`),
          dataKey: 'email_address'
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.status`),
          dataKey: 'is_enabled',
          slotName: 'switchButton'
        }
      ]
    }
  },
  methods: {
    ...mapActions('agency', ['getAgencyList', 'updateAgency']),
    async loadAgencyList () {
      this.loading = true
      try {
        const resp = await this.getAgencyList({ is_all: true })
        if (resp) {
          this.listData = resp
        }
      } finally {
        this.loading = false
      }
    },
    async changeStatus (status, agencyInfo) {
      this.loading = true
      try {
        const resp = await this.updateAgency({ agency_id: agencyInfo.agency_id, is_enabled: this.listData.find(item => item.agency_id === agencyInfo.agency_id).is_enabled, notes: agencyInfo.notes })
        if (resp) {
          this.$message.success(this.$t('common.message.optionSuccess'))
          agencyInfo.is_enabled = status
        }
      } finally {
        this.loading = false
      }
    },
    handleEdit (row) {
      this.$router.push(`/v-admin/agency/management/edit/${row.agency_id}`)
    },
    handelAddAgency () {
      this.$router.push('/v-admin/agency/management/add')
    }
  }
}
</script>

<style lang="scss" scoped>
.agency-management {
  .agency-list {

    .header-left {
      display: inline-block;
      vertical-align: middle;
      .text {
        margin-right: 10px;
        display: inline-block;
        vertical-align: middle;
      }

      .company-select {
        display: inline-block;
        vertical-align: middle;
      }
    }
    .btn-group {
      display: flex;
      justify-content: flex-end;
      .blue-btn {
        color: #0096cc;
      }
    }
  }
}

</style>
